import moment from 'moment'
import db from '@/firebase/init'

export function modulGetMessages(ref, name, userMessages, direction) {
  if (userMessages.length != 0) {
    userMessages.splice(0, userMessages.length)
  }
  ref.where(direction, '==', name).onSnapshot((snapshot => {
    snapshot.docChanges().forEach(change=>{
      if (change.type == 'added'){
        userMessages.unshift({
          from: change.doc.data().from,
          content: change.doc.data().content,
          timestamp: moment(change.doc.data().timestamp).format('lll'),
          title:change.doc.data().title,
          img:change.doc.data().img,
          to:change.doc.data().to
        })
      }
    })
  }));
}

export function modulAddMessage(ref,  message) {
      ref.add({
            content: message.content,
            from: message.from,
            timestamp: message.timestamp,
            title: message.title,
            to: message.to,
      }).then(r  =>{
        console.log('ok')
       })
}

export function modulgetUser(ref, name, friend) {
      ref.where('name', '==', name).get()
        .then(snapshot=>{
          snapshot.forEach(doc=>{
            friend = doc.data(),
            console.log(friend)
          })
        }).catch(err => {
        console.log('Error modulgetUser ', err);
      });
}

export function getImgUser(name){
  let imgpath;
  switch (name) {
    case "Stefan":
      imgpath="/static/imgs/bild03.4f47aef.jpg";
      break;
    case "Markus":
      imgpath="/static/imgs/bild02.2833a82.jpg";
      break;
    case "Patrizia":
      imgpath="/static/imgs/bild03.4f47aef.jpg";
      break;
      case "Nicole":
        imgpath="/static/imgs/bild04.bb55c0f.jpg";
      break;
    case "Harald":
      imgpath="/static/imgs/bild06.e18e495.jpg";
      break;
    case "Nathalie":
      imgpath="/static/imgs/bild01.c4687ad.jpg";
      break;
    case "Online":
      imgpath="/static/imgs/bild05.5dd8cab.jpg";
      break;
    return imgpath;
  }
}



// WEBPACK FOOTER //
// ./src/firebase/UserMessageDBFunction.js